// src/layouts/PortalLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

import '../styles/retailgo-tokens.css';
import '../styles/retailgo-foundation.css';
import './PortalLayout.css';

function PortalLayout() {
  return (
    <div className="layout-horizontal layout-wrapper">
      <Navbar />
      <div className="content-wrapper container-xxl">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

export default PortalLayout;
